<template>
    <div ref="wrapper">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        duration: {
            type: Number,
            default: 0.4
        },
        delay: {
            type: Number,
            default: 0.25
        },
        once: {
            type: Boolean,
            default: false
        },
        toggleActions: {
            type: String,
            default: 'play none play none'
        },
        startY: {
            type: String,
            default: '50'
        }
    },

    mounted() {
        gsap.fromTo(
            this.$refs.wrapper,
            {
                y: this.startY,
                opacity: 0
            },
            {
                y: 0,
                opacity: 1,
                duration: this.duration,
                delay: this.delay,
                ease: 'circ.out',
                scrollTrigger: {
                    trigger: this.$refs.wrapper,
                    once: this.once,
                    toggleActions: this.toggleActions
                }
            }
        );
    }
};
</script>
